export default __webpack_public_path__ + "static/media/solution1.c5cd55ea.png";